export function startOfDay(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function endOfDay(date: Date): Date {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
}

export function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function addMonths(date: Date, months: number): Date {
  const d = new Date(date);
  d.setMonth(d.getMonth() + months);
  return d;
}

export function addDays(date: Date, days: number): Date {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

export function startOfWeek(date: Date, weekStartsOnMonday = true): Date {
  const d = startOfDay(date);
  const day = d.getDay();
  const diff = weekStartsOnMonday ? (day === 0 ? -6 : 1 - day) : -day;
  return addDays(d, diff);
}

export function getMonthMatrix(viewDate: Date): Date[][] {
  const first = new Date(viewDate.getFullYear(), viewDate.getMonth(), 1);
  const start = startOfWeek(first, true);
  const weeks: Date[][] = [];

  let cursor = new Date(start);
  for (let w = 0; w < 6; w++) {
    const week: Date[] = [];
    for (let d = 0; d < 7; d++) {
      week.push(new Date(cursor));
      cursor = addDays(cursor, 1);
    }
    weeks.push(week);
  }

  return weeks;
}

export function formatMonthYear(date: Date): string {
  return date.toLocaleDateString('tr-TR', { month: 'long', year: 'numeric' });
}

export function formatDayLabel(date: Date): string {
  return date.toLocaleDateString('tr-TR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function formatTimeRange(start: Date, end: Date): string {
  const opts: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' };
  return `${start.toLocaleTimeString('tr-TR', opts)} – ${end.toLocaleTimeString('tr-TR', opts)}`;
}

export function toDateKey(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** HTML date input formatı: YYYY-MM-DD */
export function toDateInputValue(date: Date): string {
  return toDateKey(date);
}

/** Seçili gün için varsayılan toplantı saati (bugün ise bir sonraki saat, değilse 10:00) */
export function getDefaultMeetingTime(date: Date): string {
  const now = new Date();
  if (!isSameDay(date, now)) {
    return '10:00';
  }
  const nextHour = new Date(now);
  nextHour.setMinutes(0, 0, 0);
  nextHour.setHours(nextHour.getHours() + 1);
  const h = String(nextHour.getHours()).padStart(2, '0');
  return `${h}:00`;
}

export function buildPlanMeetingUrl(selectedDate: Date): string {
  const date = toDateInputValue(selectedDate);
  const time = getDefaultMeetingTime(selectedDate);
  return `/plans?create=true&date=${date}&time=${time}&from=calendar`;
}

export function parseDateInputValue(value: string): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const parsed = new Date(`${value}T12:00:00`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}
